import React from "react";
import {BCHeader3, BCHeader5, Body2, Subtitle2} from "../generic/BCHeaders";
import {FlexCol, FlexRow} from "../generic/Containers";
import {TESTIMONIALS_CONFIG} from "../../constants/TestimonialsConfig";

export const TestimonialsComponent: React.FC<{isEducator: boolean}> = ({isEducator}) => {
    return (
        <FlexCol gap={1.5} justify={"center"} align={"center"}>
            <BCHeader3 text="Don't Just Take Our Word for It" textAlign="center" className="landing-section-header"/>
            <FlexRow gap={1} justify="center" reverseMobile={true} maxWidth={80}>
                {TESTIMONIALS_CONFIG.items.slice(0, 3).map((testimonial, index) => (
                    <FlexCol
                        key={index}
                        padding={1}
                        gap={0.5}
                        widthPercent={100}
                        className="testimonial-card"
                        style={{
                            border: '1px solid var(--color-gray-300)',
                            borderRadius: '0.5em',
                            background: 'var(--background-container-default)',
                            width: '100%'
                        }}
                    >
                        <FlexRow align="center" gap={0.5}>
                            <img
                                src={testimonial.avatar}
                                alt={testimonial.name}
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    objectFit: 'cover'
                                }}
                            />
                            <FlexCol>
                                <BCHeader5 text={testimonial.name} />
                                <Subtitle2 text={testimonial.specialty} />
                            </FlexCol>
                        </FlexRow>
                        <Body2 text={`"${testimonial.reviewText.substring(0, 200)}..."`}  style={{fontSize: '1rem'}}/>
                    </FlexCol>
                ))}
            </FlexRow>
        </FlexCol>
    );
}